export enum THEME_COLORS {
  primary,
  link,
  visitedLink,
  black,
  error,
  success,
  tabBar,
}

/**
 * Converts a color to RGBA with 10% opacity.
 * @param {string} color - The input color (hex, rgb, or rgba).
 * @returns {string} - The color in RGBA format with 10% opacity.
 */
export function getColorWithOpacity(color: string, opacity: number) {
  if (color.startsWith("#")) {
    return blendWithWhite(color, opacity);
  }

  throw new Error("Unsupported color format. Use HEX.");
}

/**
 * Blend a hex color with a white background using a given opacity.
 * @param {string} hexColor - The color in hex format (e.g., '#RRGGBB').
 * @param {number} opacity - The opacity value (0 to 1).
 * @returns {string} - The resulting solid color in hex format.
 */
function blendWithWhite(hexColor: string, opacity: number): string {
  const hexMatch = hexColor.match(/^#([a-fA-F0-9]{6})$/);
  if (!hexMatch) {
    throw new Error("Invalid Hex color format. Expected format: #RRGGBB");
  }

  const hex = hexMatch[1];
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  const alpha = Math.min(1, Math.max(0, opacity));

  const blendedR = Math.round(r * alpha + 255 * (1 - alpha));
  const blendedG = Math.round(g * alpha + 255 * (1 - alpha));
  const blendedB = Math.round(b * alpha + 255 * (1 - alpha));

  const toHex = (value: number) => value.toString(16).padStart(2, "0");
  return `#${toHex(blendedR)}${toHex(blendedG)}${toHex(blendedB)}`;
}
